<template>
  <div class="menberInfo">
    <!-- <heads></heads> -->
    <div class="container">
      <div class="content">
        <div class="menber">
          <div class="info">
            <img :src="memberInfo.headPicPath" class="men-img" />
            <div class="name">{{memberInfo.username}}</div>
          </div>
          <div class="label">
             <span><i class="fa fa-money" aria-hidden="true"></i> 总积分：{{memberInfo.point}}</span>
               <span class="grade" v-if="memberInfo.isLeader"   @click="leaderDialogVisible = true"><i class="fa fa-user-o" aria-hidden="true"></i> 等级：领队</span>
               <span class="grade" v-else  @click="dialogVisible = true"><i class="fa fa-user-o" aria-hidden="true"></i> 等级：{{memberInfo.memberRank.name || "普通"}}</span>
                 <!-- <span><i class="fa fa-credit-card" aria-hidden="true"></i> 钱包余额：1236</span> -->
          </div>
        </div>
      </div>
    </div>
    <!-- <homeFoots></homeFoots> -->
    <el-dialog
      title="会员等级"
      :visible.sync="dialogVisible"
      class="my-dialog"
      width="20%">
      <div class="amount">您的消费金额是: {{memberInfo.amount || '0'}}元</div>
      <div>当前的等级是: {{memberInfo.memberRank.name}}</div>
      <div>下一等级是: {{nextGrade}}</div>
      <div>等级说明:</div>
      <div>普通 (消费金额0元起)</div>
      <div>青铜 (消费金额达到1000元)</div>
      <div>白银 (消费金额达到3000元)</div>
      <div>黄金 (消费金额达到5000元)</div>
      <div>铂金 (消费金额达到10000元)</div>
      <div>钻石 (消费金额达到20000元)</div>
    </el-dialog>
    <el-dialog
      title="会员等级"
      :visible.sync="leaderDialogVisible"
      class="my-dialog"
      width="20%">
      <div class="amount">您的消费金额是: {{memberInfo.amount || '0'}}元</div>
      <div>当前的等级是: 领队</div>
      <div>等级说明:</div>
      <div>普通 (消费金额0元起)</div>
      <div>青铜 (消费金额达到1000元)</div>
      <div>白银 (消费金额达到3000元)</div>
      <div>黄金 (消费金额达到5000元)</div>
      <div>铂金 (消费金额达到10000元)</div>
      <div>钻石 (消费金额达到20000元)</div>
    </el-dialog>
  </div>
</template>

<script>
import heads from "@/components/comment/heads.vue";
import homeFoots from "@/components/comment/homeFoots.vue";
import banners from "@/components/comment/banners.vue";

import axios from "axios";
export default {
  name: "menberInfo",
  data() {
    return {
      pageNumber: 1,
      total: 0,
      nav: 0,
      navArray: ["TA的活动", "个人介绍"],
      dialogVisible: false,
      leaderDialogVisible: false
    };
  },
  components: {
    heads,
    homeFoots,
    banners
  },
 computed: {
    memberInfo(){
      return this.$store.state.memberInfo
    },
    nextGrade(){
      const name = this.memberInfo.memberRank.name;
      let grade = '';
      if(name === '普通'){
        grade = '青铜'
      }else if(name === '青铜'){
        grade = '白银'
      }else if(name === '白银'){
        grade = '黄金'
      }else if(name === '黄金'){
        grade = '铂金'
      }else if(name === '铂金'){
        grade = '钻石'
      }
      return grade;
    }
  },
  methods: {
    getNav(index) {
      this.nav = index;
    },
    handleCurrentChange(val) {},
    handleSizeChange(val) {
      console.log("当前页:" + val);
    }
  },
  mounted() {},
  created() {}
};
</script>

<style scoped>
.activityIndex {
  width: 100%;
  height: 100%;
}
.container {
  text-align: left;
  margin-bottom: 20px;
}
.content {
  width: 100%;
}

.menber {
    text-align: center;
  width: 70%;
  height: 240px;
  box-shadow: 0px 0px 6px #c7c6c6;
  margin: 20px auto;
  border-radius: 6px;
  padding: 20px;
  box-sizing: border-box;
}
.info{
    margin: 0 auto;
}
.men-img {
  width: 80px;
  height: 80px;
  border-radius: 100%;
  margin: 10px 0;
}
.name {
  font-size: 16px;
}
.label{
  margin-top: 20px;
}
.label .grade {
  cursor: pointer;
}
.label .grade:hover {
  color: #007741;
}
.label>span{
  display: inline-block;
  padding: 0 10px;
  border-right: 1px solid #333333;
}
.label>span:last-child{
  border:none
}
.my-dialog {
  text-align: left;
}
.my-dialog >>> .el-dialog__header {
  /* padding: 8px 20px; */
  padding-bottom: 0px;
}
.my-dialog >>> .el-dialog__body {
  padding: 10px 20px;
  line-height: 2.2;
}
</style>



// WEBPACK FOOTER //
// src/components/userview/menberInfo.vue